import React from "react";

export default function PageBanner(props) {
  // แบนเนอร์ไม่บังคับใส่ — ไม่มีรูป (ไม่ได้สร้าง record / ไม่ได้อัปโหลด) ก็แค่โชว์พื้นสีเรียบ ไม่ให้หน้าพัง
  const imageUrl = props.banner?.image?.[0]?.url;
  let background = "#4B4F55"; // ไม่มีรูป: พื้นเทาเข้มให้หัวข้อสีขาวยังอ่านออก
  if (props.isVideo && props.banner) {
    background = `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${props.banner}) center center / cover no-repeat`;
  } else if (imageUrl) {
    background = `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${process.env.REACT_APP_API_URL}${imageUrl}) center / cover no-repeat, #D9D9D9`;
  }

  return (
    <div
      className="section relative bg-lightBg !bg-cover !bg-center"
      style={{ background }}
    >
      <div className="page-container h-[300px] items-start flex flex-col justify-end pb-[68px] relative z-10">
        <div className="flex flex-col gap-[14px]">
          {props.bannerText && (
            <p className="text-body font-medium text-left cursor-pointer text-white">
              <a href={`/${props.lang}`}>
                {props.lang === "th" ? "หน้าหลัก" : "Mainpage"}
              </a>
              {props.bannerText.map((item, i) => (
                <span
                  key={i}
                  onClick={() => {
                    if (
                      item.href &&
                      window.location.pathname !== `/${props.lang}${item.href}`
                    ) {
                      window.open(
                        `/${props.lang}${item.href}`,
                        "_self"
                      );
                    }
                  }}
                >
                  {" "}
                  / <span className="capitalize">{item.name}</span>
                </span>
              ))}
            </p>
          )}
          <h1 className="text-display font-bold text-left text-white">
            {props.lang === "th" ? props.text_th : props.text_en}
          </h1>
        </div>
      </div>
    </div>
  );
}
